import { useEffect, useState } from 'react';
import './App.css';
import HerosComponent from './Components/HerosComponent';
import Hero from './Classes/Hero';

const App = () => {

	const [season, setSeason] = useState("")
	const [classicHeroes, setClassicHeroes] = useState([])
	const [blitzHeroes, setBlitzHeroes] = useState([])

	useEffect(() => {
		async function fetchData() {

			const response = await fetch('http://api.fab.lrojon.fr/hero', {
				method: "GET",
				headers: {
					"Content-Type": "application/json"
				}
			})
			const data = await response.json()
			console.log(data)

			const tmp_bh = []
			const tmp_ch = []
			for(const bh of data.blitz) {
				tmp_bh.push(new Hero(bh.name, bh.seasonPoint, bh.allTimePoint))
			}
			for(const ch of data.cc) {
				tmp_ch.push(new Hero(ch.name, ch.seasonPoint, ch.allTimePoint))
			}

			setBlitzHeroes(tmp_bh)
			setClassicHeroes(tmp_ch)
			setSeason(data.season)
		}

		fetchData()
	}, [])

    if(classicHeroes.length > 0) {
		return (
			<div className="App">
				<div className='header' >
					<h1>Living Legend Status</h1>
					<h3>Current Season : {season}</h3>
				</div>
				<div className='body' >
					<div className='part' >
						<div className='title' >
							Classic Constructed
						</div>
						<div className='list' >
							{
								classicHeroes.map((elem, idx) => {
									return <HerosComponent key={idx} hero={elem} />
								})
							}
						</div>
					</div>
					<div className='part' >
						<div className='title' >
							Blitz
						</div>
						<div className='list' >
							{
								blitzHeroes.map((elem, idx) => {
									return <HerosComponent key={idx} hero={elem} />
								})
							}
						</div>
					</div>
				</div>
			</div>
		);
	} else {
		<div className='App'>
			Loading...
		</div>
	}
}

export default App;
